import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "under-cart__sum" };
const _hoisted_2 = { class: "cart-sum__main" };
const _hoisted_3 = { class: "cart-sum__list" };
const _hoisted_4 = { class: "cart-sum__value" };
const _hoisted_5 = { class: "cart-sum__value" };
const _hoisted_6 = { class: "cart-sum__value cart-sum__value--main" };
const _hoisted_7 = { class: "cart-sum__bottom" };
import { computed } from "vue";
import LoadingPrice from "./LoadingPrice.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Totals',
    props: {
        initialized: Boolean,
        totalSum: { type: Number, required: true },
        totalDiscount: Number,
    },
    setup(__props) {
        const props = __props;
        const noDiscount = computed(() => props.totalSum + props.totalDiscount);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["cart-sum", { loading: !__props.initialized }])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("dl", _hoisted_3, [
                            (__props.totalDiscount || !__props.initialized)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "cart-sum__label" }, "Сумма без скидки", -1 /* CACHED */)),
                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                    _createElementVNode("dd", _hoisted_4, [
                                        _createVNode(LoadingPrice, {
                                            amount: noDiscount.value,
                                            width: "80",
                                            height: "19",
                                            loading: !__props.initialized
                                        }, null, 8 /* PROPS */, ["amount", "loading"])
                                    ]),
                                    _cache[2] || (_cache[2] = _createTextVNode()),
                                    _cache[3] || (_cache[3] = _createElementVNode("dt", { class: "cart-sum__label" }, "Скидка на товары", -1 /* CACHED */)),
                                    _cache[4] || (_cache[4] = _createTextVNode()),
                                    _createElementVNode("dd", _hoisted_5, [
                                        _createVNode(LoadingPrice, {
                                            amount: 0 - __props.totalDiscount,
                                            width: "70",
                                            height: "18",
                                            loading: !__props.initialized
                                        }, null, 8 /* PROPS */, ["amount", "loading"])
                                    ])
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                            _cache[5] || (_cache[5] = _createTextVNode()),
                            _cache[6] || (_cache[6] = _createElementVNode("dt", { class: "cart-sum__label" }, "Итого", -1 /* CACHED */)),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _createElementVNode("dd", _hoisted_6, [
                                _createVNode(LoadingPrice, {
                                    amount: __props.totalSum,
                                    width: "90",
                                    height: "22",
                                    loading: !__props.initialized
                                }, null, 8 /* PROPS */, ["amount", "loading"])
                            ])
                        ])
                    ]),
                    _cache[9] || (_cache[9] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("a", {
                            href: "/order/",
                            class: _normalizeClass(["btn btn--1 btn--l btn--black wide", { 'btn--loading': !__props.initialized }])
                        }, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("span", { class: "btn__label" }, "Оформить заказ", -1 /* CACHED */)
                            ]))], 2 /* CLASS */)
                    ])
                ], 2 /* CLASS */)
            ]));
        };
    }
});
